import { FundingMatchStatus } from 'enums/funding-match-status';

export const CloseSearchReason = Object.freeze({
  affordability: 12,
  alreadyBeenToMarket: 26,
  approvedButTooExpensive: 24,
  approvedButNotEnough: 25,
  businessDoesntFitOurCriteria: 1,
  clientWentWithAnotherProvider: 7,
  doesNotMeetAffordabilityCriteria: 8,
  existingClient: 15,
  existingCustomer: 2,
  fraud: 19,
  fundedByAnotherLender: 21,
  fundedByAnotherMethod: 22,
  insufficientEquityCoverage: 9,
  lostContact: 6,
  needHasGone: 27,
  negativeBusinessCreditInformation: 3,
  negativePersonalCreditInformation: 4,
  noUkResidents: 13,
  notFitForProduct: 0,
  other: 10,
  poorBusinessCredit: 17,
  poorPersonalCredit: 16,
  previousLiquidations: 14,
  referedToThirdParty: 11,
  suspectThisisFraud: 5,
  tooMuchExistingDebt: 18,
  unresponsive: 20,
  unwillingToProvideNecessarySecurity: 23,
  outsideAssetTypes: 24,
  outsideGeography: 25,
  outsideBusinessAge: 26,
  doesNotMeetCreditPolicy: 27,
  doesNotMeetLenderCriteria: 28,
  dealFellThrough: 29,
});

export const CloseSearchReasonLabel = Object.freeze({
  [CloseSearchReason.affordability]: 'Affordability',
  [CloseSearchReason.alreadyBeenToMarket]: 'Already been to market',
  [CloseSearchReason.approvedButTooExpensive]: 'Approved but not enough',
  [CloseSearchReason.approvedButNotEnough]: 'Approved but too expensive',
  [CloseSearchReason.businessDoesntFitOurCriteria]: "Business doesn't fit our criteria",
  [CloseSearchReason.clientWentWithAnotherProvider]: 'Client went with another provider',
  [CloseSearchReason.doesNotMeetAffordabilityCriteria]: 'Does not meet affordability criteria',
  [CloseSearchReason.existingClient]: 'Existing client (tried too recently)',
  [CloseSearchReason.existingCustomer]: 'Existing customer',
  [CloseSearchReason.fraud]: 'Fraud',
  [CloseSearchReason.fundedByAnotherLender]: 'Funded by another lender',
  [CloseSearchReason.fundedByAnotherMethod]: 'Funded by another method (friends, investment, etc)',
  [CloseSearchReason.insufficientEquityCoverage]: 'Insufficient equity coverage',
  [CloseSearchReason.lostContact]: 'Lost contact',
  [CloseSearchReason.needHasGone]: 'Need has gone',
  [CloseSearchReason.negativeBusinessCreditInformation]: 'Negative business credit information',
  [CloseSearchReason.negativePersonalCreditInformation]: 'Negative personal credit information',
  [CloseSearchReason.notFitForProduct]: 'Not fit for our product',
  [CloseSearchReason.noUkResidents]: 'No UK residents or security',
  [CloseSearchReason.other]: 'Other',
  [CloseSearchReason.poorBusinessCredit]: 'Poor business credit',
  [CloseSearchReason.poorPersonalCredit]: 'Poor personal credit',
  [CloseSearchReason.previousLiquidations]: 'Previous liquidations',
  [CloseSearchReason.referedToThirdParty]: 'Referred to a 3rd party',
  [CloseSearchReason.suspectThisisFraud]: 'I suspect this is fraud',
  [CloseSearchReason.tooMuchExistingDebt]: 'Too much existing debt',
  [CloseSearchReason.unresponsive]: 'Unresponsive',
  [CloseSearchReason.unwillingToProvideNecessarySecurity]:
    'Unwilling to provide necessary security',
  [CloseSearchReason.outsideAssetTypes]: 'Outside asset types',
  [CloseSearchReason.outsideGeography]: 'Outside geography',
  [CloseSearchReason.outsideBusinessAge]: 'Outside business age',
  [CloseSearchReason.doesNotMeetCreditPolicy]: 'Does not meet credit policy',
  [CloseSearchReason.doesNotMeetLenderCriteria]: 'Does not meet lender criteria',
  [CloseSearchReason.dealFellThrough]: 'Deal Fell Through',
});

export const toOptions = (values = CloseSearchReason) =>
  Object.values(values).map((value) => ({ label: CloseSearchReasonLabel[value], value }));

export const groupedOptions = (status) => [
  ...(status === FundingMatchStatus.clientDecline
    ? []
    : [
        {
          label: 'Lender Decline',
          options: toOptions([
            CloseSearchReason.affordability,
            CloseSearchReason.noUkResidents,
            CloseSearchReason.previousLiquidations,
            CloseSearchReason.existingClient,
            CloseSearchReason.poorPersonalCredit,
            CloseSearchReason.poorBusinessCredit,
            CloseSearchReason.tooMuchExistingDebt,
            CloseSearchReason.fraud,
            CloseSearchReason.outsideAssetTypes,
            CloseSearchReason.outsideGeography,
            CloseSearchReason.outsideBusinessAge,
            CloseSearchReason.doesNotMeetCreditPolicy,
            CloseSearchReason.doesNotMeetLenderCriteria,
          ]),
        },
      ]),
  ...(status === FundingMatchStatus.lenderDecline
    ? []
    : [
        {
          label: 'Client Decline',
          options: toOptions([
            CloseSearchReason.unresponsive,
            CloseSearchReason.needHasGone,
            CloseSearchReason.fundedByAnotherLender,
            CloseSearchReason.fundedByAnotherMethod,
            CloseSearchReason.unwillingToProvideNecessarySecurity,
            CloseSearchReason.approvedButTooExpensive,
            CloseSearchReason.approvedButNotEnough,
          ]),
        },
      ]),
  {
    label: 'Other',
    options: toOptions([
      CloseSearchReason.alreadyBeenToMarket,
      CloseSearchReason.referedToThirdParty,
      CloseSearchReason.dealFellThrough,
      CloseSearchReason.other,
    ]),
  },
];
